import { render, staticRenderFns } from "./rectangle.vue?vue&type=template&id=630b1a15&scoped=true&"
import script from "./rectangle.vue?vue&type=script&lang=js&"
export * from "./rectangle.vue?vue&type=script&lang=js&"
import style0 from "./rectangle.vue?vue&type=style&index=0&id=630b1a15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630b1a15",
  null
  
)

export default component.exports